import { userRole } from '../constants/enum';

/**
 * 運営スタッフかどうかを判定する
 * @param role - ユーザーのロール
 * @returns 運営スタッフの場合 true
 */
export const isOperatorStaff = (role: number | null | undefined): boolean => {
  if (role === undefined || role === null) return false;
  return role === userRole.admin || role === userRole.operator;
};

/**
 * 運営管理者権限を持つかどうかを判定する
 * @param role - ユーザーのロール
 * @returns 運営管理者の場合 true
 */
export const isOperatorAdmin = (role: number | null | undefined): boolean => {
  if (role === undefined || role === null) return false;
  return role === userRole.admin;
};

/**
 * 企業管理者権限を持つかどうかを判定する
 * @param role - ユーザーのロール
 * @returns 企業管理者の場合 true
 */
export const isCompanyAdmin = (role: number | null | undefined): boolean => {
  if (role === undefined || role === null) return false;
  return role === userRole.companyAdmin;
};

/**
 * 企業メンバー権限を持つかどうかを判定する
 * @param role - ユーザーのロール
 * @returns 企業メンバーの場合 true
 */
export const isCompanyMember = (role: number | null | undefined): boolean => {
  if (role === undefined || role === null) return false;
  return role === userRole.companyMember;
};

/**
 * 管理者権限を持つかどうかを判定する
 * 運営管理者または企業管理者の場合に true を返す
 * @param role - ユーザーのロール
 * @returns 管理者権限を持つ場合 true
 */
export const hasAdminPermission = (role: number | null | undefined): boolean => {
  if (role === undefined || role === null) return false;
  return role === userRole.admin || role === userRole.companyAdmin;
};

/**
 * 一般メンバー以外の権限を持つかどうかを判定する
 * 運営スタッフまたは企業管理者の場合に true を返す
 * @param role - ユーザーのロール
 * @returns 一般メンバー以外の権限を持つ場合 true
 */
export const isNotCompanyMember = (role: number | null | undefined): boolean => {
  if (role === undefined || role === null) return false;
  return role === userRole.admin || role === userRole.operator || role === userRole.companyAdmin;
};

/**
 * メンバー以上の権限を持つかどうかを判定する
 * すべての有効なロールの場合に true を返す
 * @param role - ユーザーのロール
 * @returns メンバー以上の権限を持つ場合 true
 */
export const hasMemberPermission = (role: number | null | undefined): boolean => {
  if (role === undefined || role === null) return false;
  return (
    role === userRole.admin ||
    role === userRole.operator ||
    role === userRole.companyAdmin ||
    role === userRole.companyMember
  );
};
